
import { createRouter, createWebHistory } from 'vue-router'
import Navbarpage from '../dashbaord/Pages/navbarpage.vue'
import Carouselpages from '../dashbaord/Pages/carouselpages.vue'
import Principle from '../dashbaord/Pages/principle.vue'
import Footer from '../dashbaord/Pages/footer.vue'
import latestnews from '../dashbaord/Pages/latestnews.vue'


import Index from '../dashbaord/index.vue'
import Home from '../website/Home.vue'
import Latestnews from '../dashbaord/Pages/latestnews.vue'



const routes = [
  { path: '/', component: Home },
  { path: '/dashboard', component: Index },
  { path: '/dashboard/navbar', component: Navbarpage },
  { path: '/dashboard/carousel', component: Carouselpages },
  { path: '/dashboard/principle', component: Principle },
  { path: '/dashboard/footer', component: Footer },
  { path: '/dashboard/latestnews', component: Latestnews },
] 

 const router = createRouter({
  history: 	createWebHistory(),
  routes,
})

export default router